// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.translatable-label {
    align-items: center;
    display: flex;
    gap: 6px;
    margin-bottom: 4px;
}

.translatable-label label {
    margin: 0;
}

.translatable-label button.translatable-field-trigger {
    align-items: center;
    appearance: none;
    background-color: transparent;
    border: 0;
    color: #68736b;
    cursor: pointer;
    display: inline-flex;
    font-size: 0.95rem;
    font-weight: normal;
    gap: 3px;
    padding: 2px 4px;
}

.translatable-label button.translatable-field-trigger:hover,
.translatable-label button.translatable-field-trigger:focus-visible,
.translatable-label button.translatable-field-trigger.has-translations {
    background-color: transparent;
    color: #316c29;
}

.translatable-field-count {
    font-size: 0.7rem;
    font-weight: 700;
}

.translatable-field-source {
    background: #f7f7f7;
    border-radius: 6px;
    margin-bottom: 18px;
    padding: 10px 12px;
    white-space: pre-wrap;
}

.translatable-field-list {
    border-bottom: 1px solid #ddd;
    margin-bottom: 18px;
}

.translatable-field-row {
    align-items: flex-start;
    border-top: 1px solid #ddd;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 10px 0;
    white-space: pre-wrap;
}

.translatable-field-actions,
.translatable-field-form-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.translatable-field-form h3 {
    font-size: 1.05rem;
    margin: 0 0 12px;
}

.translatable-field-delete-all {
    color: #8a6666;
    display: inline-block;
    font-size: 0.82rem;
    margin-top: 18px;
}

.translatable-field-delete-all:hover,
.translatable-field-delete-all:focus-visible {
    color: #714c4c;
}

[data-theme="dark"] .translatable-label button.translatable-field-trigger { color: #9fb0a6; }
[data-theme="dark"] .translatable-label button.translatable-field-trigger:hover,
[data-theme="dark"] .translatable-label button.translatable-field-trigger:focus-visible,
[data-theme="dark"] .translatable-label button.translatable-field-trigger.has-translations {
    color: #8fd6a0;
}
[data-theme="dark"] .translatable-field-source { background: #222f28; }
[data-theme="dark"] .translatable-field-list,
[data-theme="dark"] .translatable-field-row { border-color: #3a463e; }
[data-theme="dark"] .translatable-field-delete-all { color: #b99797; }
[data-theme="dark"] .translatable-field-delete-all:hover,
[data-theme="dark"] .translatable-field-delete-all:focus-visible { color: #d0adad; }

@media (max-width: 480px) {
    .translatable-field-row {
        display: block;
    }

    .translatable-field-actions {
        margin-top: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TranslatableField.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;;IAGI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,eAAe;IACf,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;;AAEA,4EAA4E,cAAc,EAAE;AAC5F;;;IAGI,cAAc;AAClB;AACA,iDAAiD,mBAAmB,EAAE;AACtE;8CAC8C,qBAAqB,EAAE;AACrE,qDAAqD,cAAc,EAAE;AACrE;mEACmE,cAAc,EAAE;;AAEnF;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".translatable-label {\n    align-items: center;\n    display: flex;\n    gap: 6px;\n    margin-bottom: 4px;\n}\n\n.translatable-label label {\n    margin: 0;\n}\n\n.translatable-label button.translatable-field-trigger {\n    align-items: center;\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    color: #68736b;\n    cursor: pointer;\n    display: inline-flex;\n    font-size: 0.95rem;\n    font-weight: normal;\n    gap: 3px;\n    padding: 2px 4px;\n}\n\n.translatable-label button.translatable-field-trigger:hover,\n.translatable-label button.translatable-field-trigger:focus-visible,\n.translatable-label button.translatable-field-trigger.has-translations {\n    background-color: transparent;\n    color: #316c29;\n}\n\n.translatable-field-count {\n    font-size: 0.7rem;\n    font-weight: 700;\n}\n\n.translatable-field-source {\n    background: #f7f7f7;\n    border-radius: 6px;\n    margin-bottom: 18px;\n    padding: 10px 12px;\n    white-space: pre-wrap;\n}\n\n.translatable-field-list {\n    border-bottom: 1px solid #ddd;\n    margin-bottom: 18px;\n}\n\n.translatable-field-row {\n    align-items: flex-start;\n    border-top: 1px solid #ddd;\n    display: flex;\n    gap: 12px;\n    justify-content: space-between;\n    padding: 10px 0;\n    white-space: pre-wrap;\n}\n\n.translatable-field-actions,\n.translatable-field-form-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.translatable-field-form h3 {\n    font-size: 1.05rem;\n    margin: 0 0 12px;\n}\n\n.translatable-field-delete-all {\n    color: #8a6666;\n    display: inline-block;\n    font-size: 0.82rem;\n    margin-top: 18px;\n}\n\n.translatable-field-delete-all:hover,\n.translatable-field-delete-all:focus-visible {\n    color: #714c4c;\n}\n\n[data-theme=\"dark\"] .translatable-label button.translatable-field-trigger { color: #9fb0a6; }\n[data-theme=\"dark\"] .translatable-label button.translatable-field-trigger:hover,\n[data-theme=\"dark\"] .translatable-label button.translatable-field-trigger:focus-visible,\n[data-theme=\"dark\"] .translatable-label button.translatable-field-trigger.has-translations {\n    color: #8fd6a0;\n}\n[data-theme=\"dark\"] .translatable-field-source { background: #222f28; }\n[data-theme=\"dark\"] .translatable-field-list,\n[data-theme=\"dark\"] .translatable-field-row { border-color: #3a463e; }\n[data-theme=\"dark\"] .translatable-field-delete-all { color: #b99797; }\n[data-theme=\"dark\"] .translatable-field-delete-all:hover,\n[data-theme=\"dark\"] .translatable-field-delete-all:focus-visible { color: #d0adad; }\n\n@media (max-width: 480px) {\n    .translatable-field-row {\n        display: block;\n    }\n\n    .translatable-field-actions {\n        margin-top: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
